import { useEffect, useState } from "react";

/**
 * Hook, ktorý poskytuje ticker aktualizovaný každú sekundu.
 * Používa singleton pattern - len jeden interval beží pre všetky komponenty.
 *
 * @returns {number} Aktuálny timestamp, ktorý sa mení každú sekundu
 */

let globalTicker = Date.now();
let listenerCount = 0;
let intervalId: NodeJS.Timeout | null = null;
const listeners = new Set<(ticker: number) => void>();

const startGlobalInterval = () => {
    if (intervalId === null) {
        intervalId = setInterval(() => {
            globalTicker = Date.now();
            listeners.forEach((listener) => listener(globalTicker));
        }, 1000);
    }
};

const stopGlobalInterval = () => {
    if (intervalId !== null && listenerCount === 0) {
        clearInterval(intervalId);
        intervalId = null;
    }
};

// Export pre testy - reset globálneho stavu
export const resetSecondTicker = () => {
    if (intervalId !== null) {
        clearInterval(intervalId);
        intervalId = null;
    }
    listeners.clear();
    listenerCount = 0;
    globalTicker = Date.now();
};

export const useSecondTicker = (): number => {
    const [ticker, setTicker] = useState(globalTicker);

    useEffect(() => {
        listenerCount++;

        const listener = (newTicker: number) => {
            setTicker(newTicker);
        };

        listeners.add(listener);
        startGlobalInterval();

        return () => {
            listenerCount--;
            listeners.delete(listener);
            stopGlobalInterval();
        };
    }, []);

    return ticker;
};
